<template>
  <fo-layout>
    <div  class="contact-honor">
      <div class="backimg-box">
        <div class="backimg centerimage"
          style="background-image: url(https://suisuixiang.oss-cn-beijing.aliyuncs.com/stev%2A%2A%2A%2Acom/2021-06-18/WechatIMG573.jpeg);"></div>
        <div  class="honor-bar">
          <p class="white title-alt" v-if="headlineText[3]">{{headlineText[3].sub_title}}</p>
          <h1 class="white title" v-if="headlineText[3]">{{headlineText[3].title}}</h1>
        </div>
      </div>
      <div class="honor-content">
        <div class="pr ht-100x">
          <div class="navigatio-bar">
            <span @click="clickSapn(item)"
              :class="item.data === clickData ? 'sele' : ''"
              v-for="(item, i) in navigatioData"
              :key="i">{{item.data}}</span>
          </div>
          <div class="time-list">
             <div class="ta-c" v-if="readItemsLoading">
              <a-spin />
            </div>
            <ul v-else>
              <li v-for="(item, i) in honorData" :key="i">
                <p class="date"><a-icon type="calendar" theme="filled" /> {{item.honor_year}}</p>
                <p class="intro" @click="goToPage(item.honor_link_url)">{{item.honor_content}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </fo-layout>
</template>
<script type="text/javascript">
export default {
  data () {
    return {
      // 保存荣誉数据
      honorData: [],
      // 标题数据
      headlineText: [],
      // 荣誉查询状态
      readItemsLoading: false,
      // 荣誉查询条件
      honorCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 999,
        // 关键词搜索
        keyword: '',
        // 按年搜索
        honor_year: '2021'
      },
      // 保存点击时间的数据
      clickData: '2021',
      // 保存时间数据
      navigatioData: [
        {
          data: '2021'
        }, {
          data: '2020'
        }, {
          data: '2019'
        }, {
          data: '2018'
        }
      ]
    }
  },
  mounted () {
    this.readHonorItems()
    this.headlineItems()
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    headlineItems () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          var data = JSON.parse(r.data.value)
          for (var i of data) {
            if (i.label_en === 'About Us' || i.label_zh === '关于我们') {
              this.headlineText = i.children
            }
          }
        } else {
          this.error(r.msg)
        }
      })
    },
    // 点击的年份
    clickSapn (e) {
      this.clickData = e.data
      this.honorCond.honor_year = e.data
      this.readItems()
    },
    /*
    * 查询荣誉时间
    */
    readHonorItems () {
      this.readItemsLoading = true
      this.get({
        url: 'honorRead',
        data: {
          page_num: 1,
          page_size: 999
        }
      }, (r) => {
        this.readItemsLoading = false
        if (r.code) {
          console.log(r.data.items)
          let itemsData = []
          this.navigatioData = []
          for (let data of r.data.items) {
            if (itemsData.indexOf(data.honor_year) === -1) {
              itemsData.push(data.honor_year)
              this.navigatioData.push({
                data: data.honor_year
              })
            }
          }
          this.clickData = this.navigatioData[0].data
          this.honorCond.honor_year = this.navigatioData[0].data
          this.readItems()
        } else {
          this.error(r.msg)
        }
      })
    },
    /*
    * 查询荣誉
    */
    readItems () {
      this.readItemsLoading = true
      this.get({
        url: 'honorRead',
        data: this.honorCond
      }, (r) => {
        this.readItemsLoading = false
        if (r.code) {
          this.honorData = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    },
    goToPage (router) {
      window.open(router)
    }
  }
}
</script>
<style lang="less">
@import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
/* 左侧背景图宽高 */
@backimgWidth: 480px;
@backimgHeight: 700px;
/* 右侧内容宽度 */
@contentWidth: 76%;
/* 左侧标题宽度 */
@honorBarWidth: 24%;
.contact-honor {
  height: @backimgHeight;
  position: relative;
  /*.backimg-box {
    .backimg {
      height: @backimgHeight;
      width: @backimgWidth;
      position: absolute;
      right: @contentWidth;
    }
  }*/
  .honor-bar {
    font-family: Georgia, 宋体;
    position: relative;
    z-index: 2;
    padding: 0 16px;
    .title-alt {
      font-size: 14px;
      margin: 0;
      color: @primary;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      color: @primary;
    }
  }
  .honor-content {
    width: 100%;
    padding: 0 0 0 16px;
    position: absolute;
    height: 100%;
    top: 0;
    .navigatio-bar {
      width: 100%;
      border-bottom: 1px solid @primary;
      position: absolute;
      // left: ;
      bottom: 580px;
      overflow: auto;
      white-space: nowrap;
      span {
        display: inline-block;
        text-align: center;
        width: 120px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        font-size: 20px;
      }
      span:hover,
      span.sele {
        color: #fff;
        background-color: @primary;
      }
    }
    .time-list {
      height: 100%;
      padding-top: 140px;
      ul {
        list-style-type: none;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: rgba(0,0,0,0.1);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.6);
          border-radius: 3px;
        }
      }
      li {
        padding:5px 0 40px 50px;
        position: relative;
        &:before {
          content: '';
          height: 100%;
          border-left: 1px solid @support;
          position: absolute;
          left: 10px;
          top: 8px;
        }
        &:after {
          content: '';
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: @support;
          position: absolute;
          left: 3px;
          top: 6px;
        }
      }
      .date {
        font-size: 16px;
        color: @support;
        margin-bottom: 10px;
      }
      .intro {
        font-family: Georgia;
        font-size: 18px;
        font-weight: bold;
        line-height: 32px;
        margin: 0;
        cursor: pointer;
      }
      p.intro:hover {
        color: @primary;
      }
    }
  }
}
}
/* 大于 750 */
@media screen and (min-width: 751px) {
/* 左侧背景图宽高 */
@backimgWidth: 480px;
@backimgHeight: 700px;
/* 右侧内容宽度 */
@contentWidth: 76%;
/* 左侧标题宽度 */
@honorBarWidth: 24%;
.contact-honor {
  height: @backimgHeight;
  position: relative;
  .backimg-box {
    .backimg {
      height: @backimgHeight;
      width: @backimgWidth;
      position: absolute;
      right: @contentWidth;
    }
  }
  .honor-bar {
    width: @honorBarWidth;
    font-family: Georgia, 宋体;
    padding-top: 60px;
    position: relative;
    z-index: 2;
    .title-alt {
      font-size: 16px;
      margin: 0;
    }
    .title {
      font-size: 4em;
      font-weight: bold;
      margin: 0;
    }
  }
  .honor-content {
    width: @contentWidth;
    padding-left: 8%;
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    .navigatio-bar {
      width: 100%;
      border-bottom: 1px solid @primary;
      position: absolute;
      left: 0;
      top: 0;
      span {
        display: inline-block;
        text-align: center;
        width: 120px;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        font-size: 20px;
      }
      span:hover,
      span.sele {
        color: #fff;
        background-color: @primary;
      }
    }
    .time-list {
      height: 100%;
      padding-top: 120px;
      ul {
        list-style-type: none;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: rgba(0,0,0,0.1);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.6);
          border-radius: 3px;
        }
      }
      li {
        padding:0 0 40px 50px;
        position: relative;
        &:before {
          content: '';
          height: 100%;
          border-left: 2px solid @support;
          position: absolute;
          left: 10px;
          top: 8px;
        }
        &:after {
          content: '';
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: @support;
          position: absolute;
          left: 0;
          top: 6px;
        }
      }
      .date {
        font-size: 22px;
        color: @support;
        margin-bottom: 10px;
      }
      .intro {
        font-family: Georgia;
        font-size: 26px;
        font-weight: bold;
        line-height: 32px;
        margin: 0;
        cursor: pointer;
      }
      p.intro:hover {
        color: @primary;
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/honor.vue